// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TPO2","col":"styles_col__3yEXD"};